import React, { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "./dashboard.scss"
import {
  Card,
  Row,
  Col,
  ListGroup,
  ButtonGroup,
  Dropdown,
} from "react-bootstrap"
import { Doughnut, Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js"
import { FaCaretDown } from "react-icons/fa"
import patientImage from "../../assets/images/patient.svg"
import consultantImage from "../../assets/images/consultant.svg"
import vaccination from "../../assets/images/vaccinnation.svg"
import BarChart from "components/Dashboard/BarChart"
import DoctorSchedule from "components/Dashboard/ScheduelList"
import UpcomingBirthdays from "../../components/Dashboard/UpcomingBirthday"
import DashBoardHeader from "../../components/Dashboard/DashboardHeader"
import { DonutChart } from "components/Dashboard/DonutChart"
import { fetchDashboardApi, fetchDashboardApiTwo } from "helpers/api_helper"
import { useDispatch, useSelector } from "react-redux"
import { fetchPetTypes, getDashboardApiTwo, getDashboardData, getTypes, getUserDetails, setGlobalLoading } from "store/slices"
import appConstants  from "../../constants/appConstants/appConstants.json"
import { extractConsultationsTypeCounts } from "helpers/dashboardHelper"
import { IconSVG } from "components/Common/IconSvg"
import { useHistory } from 'react-router-dom'
import { capitalizeFirstLetter } from "helpers/commonHelpers"
import RescheduleAppointmentModal from "components/Appointments/RescheduleAppointmentModal"
import { getTodaysAppointments } from "store/slices"
import { getAppointmentDisplayLabel } from "helpers/utils"

// Register Chart.js components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
)

const normalizeAppointmentStatus = status => {
  const normalized = String(status || "").trim().toLowerCase()
  const map = {
    scheduled: "scheduled",
    "check-in": "checkin",
    checkin: "checkin",
    completed: "completed",
    cancelled: "cancelled",
    canceled: "cancelled",
    accepted: "accepted",
    rescheduled: "rescheduled",
    all: "all",
    open: "scheduled,checkin,accepted",
  }
  return map[normalized] || normalized.replace(/[-_\s]/g, "") || "scheduled"
}

function Dashboard() {

  const [appointmentLoading, setAppointmentLoading] = useState(false);
  const [appointment, setAppointment] = useState([]);
  const [appointmentError, setAppointmentError] = useState(null);
  const [firstApiResponse, setFirstApiResponse] = useState({});
  const [appointmentType, setAppointmentType] = useState("all");
  const [timeRange, setTimeRange] = useState({
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toLocaleDateString("in"),
    endDate: new Date().toLocaleDateString("in") 
  });
  const [appointmentStatus, setAppointmentStatus] = useState("All");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [rescheduleModalOpen, setRescheduleModalOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const dashboardStoreData = useSelector(getDashboardData);
  const userDetails = useSelector(getUserDetails);
  const petTypes = useSelector(getTypes);

  const formatDateForApi = dateString =>
    dateString?.split("/").reverse().join("-")

  const normalizePetTypeForApi = petType =>
    petType?.toString().trim().toLowerCase() === "all"
      ? ""
      : petType?.toString().trim().toLowerCase()

  const extractDashboardAppointments = data =>
    data?.appointments ||
    data?.dashboardResponse?.appointments ||
    data?.dashboardResponse?.data?.appointments ||
    data?.data?.appointments ||
    data?.data?.dashboardResponse?.appointments ||
    []

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
  if (userDetails?._id) {
    dashboardData(true);
  }
}, [userDetails?._id]);

useEffect(() => {
  if (userDetails?._id) {
    dashboardData(false);
  }
}, [userDetails?._id, appointmentStatus, appointmentType, timeRange.startDate, timeRange.endDate]);
  
  async function dashboardData(showFullLoader = true) {
  if (showFullLoader) {
    dispatch(setGlobalLoading(true))
  }
    setAppointmentLoading(true)
    setAppointmentError(null)
    try {
      const params = {
        doctorId: userDetails._id,
        vetId: userDetails._id,
        startDate: formatDateForApi(timeRange.startDate),
        endDate: formatDateForApi(timeRange.endDate),
        petType: normalizePetTypeForApi(appointmentType),
      }
      const normalizedStatus = normalizeAppointmentStatus(appointmentStatus)
      if (normalizedStatus !== "all") {
        params.status = normalizedStatus
      }
      console.log("[DASHBOARD] fetchDashboardApi params:", params)
      const [response, _, __ ] = await Promise.all([
        fetchDashboardApi(params),
        dispatch(getDashboardApiTwo(
          normalizePetTypeForApi(appointmentType), 
          userDetails._id, 
          timeRange.startDate.split("/").reverse().join("-"), 
          timeRange.endDate.split("/").reverse().join("-")
        )),
        dispatch(fetchPetTypes())
      ])

      if (response && response.status === 1) {
        setAppointmentError(null)
        const dashboardData = response.data?.data || response.data?.dashboardResponse || response.data
        setFirstApiResponse(dashboardData)
        setAppointment(extractDashboardAppointments(response.data))
      } else {
        setAppointment([])
        setAppointmentError(response?.message || "Unable to load appointments")
      }
    } catch (error) {
      console.error("Dashboard API error:", error)
      setAppointment([])
      setAppointmentError(error?.message || "Unable to load appointments")
    } finally {
      setAppointmentLoading(false)
      if (showFullLoader) {
        dispatch(setGlobalLoading(false))
      }
    }
  }

  const handleApplyRange = () => {
    dashboardData(true);
  }

  const handleRescheduleAppointment = (appointment) => {
    setSelectedAppointment(appointment)
    setRescheduleModalOpen(true)
  }

  const handlePrintPrescription = (appointmentId) => {
    history.push(`/prescription-details/${appointmentId}`)
  }


  return (
    <div className="px-3 " style={{ backgroundColor: "#F0F2F3" }}>
      <DashBoardHeader setTimeRange={setTimeRange} timeRange={timeRange} handleApplyRange={handleApplyRange}/>
      <RescheduleAppointmentModal
        isOpen={rescheduleModalOpen}
        onClose={() => {
          setRescheduleModalOpen(false)
          setSelectedAppointment(null)
        }}
        appointmentData={selectedAppointment}
        onSuccess={updatedAppointment => {
          if (updatedAppointment?._id) {
            setAppointment(currentAppointments =>
              currentAppointments.map(item =>
                item?._id === updatedAppointment._id ? updatedAppointment : item
              )
            )
          }
          dispatch(getTodaysAppointments())
          return dashboardData(false)
        }}
      />

      {/* First Row: Stats */}
      <Row className="align-items-stretch">
        <Col xxl={9}>
          <Row className="mb-3 sm-gap">
            <Col sm={12} md={4}>
              <StatsCard title={appConstants.NEW_PATIENTS} value={firstApiResponse?.newPatients} icon={patientImage} />
            </Col>
            <Col sm={12} md={4}>
              <StatsCard
                title={appConstants.CONSULTATIONS}
                value={firstApiResponse?.consultations}
                icon={consultantImage}
              />
            </Col>
            <Col sm={12} md={4}>
              <StatsCard
                title={appConstants.VACCINATIONS_DATA}
                value={firstApiResponse?.vaccinationsData}
                icon={vaccination}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} sm={6} lg={4}>
              <DonutChart
                title={appConstants.PET_TYPES}
                data={firstApiResponse?.petCountAndTypeDistribution?.map((pet) => { return pet.counts?.Male + pet.counts?.Female || 0}) || []}
                labels={firstApiResponse?.petCountAndTypeDistribution?.map((pet) => pet.petType) || []}
                colors={Object.values(appConstants.THEME_COLORS)}
                text={appConstants.PETS}
                genderDistribution={firstApiResponse?.petCountAndTypeDistribution?.map((pet) => { return { Male: pet.counts?.Male, Female: pet.counts?.Female }})}
              />
            </Col>
            <Col xs={12} lg={4}>
              <BarChart
                title={appConstants.TOP_INVENTORY_ITEM_SOLD}
                labels={["Dolo", "Formosent 500", "Disprin", "Combiflam", "Olfagol 250"]}
                data={[ 100, 80, 78, 60, 44]}
                thickness={15}
              />
            </Col>
            <Col xs={12} lg={4}>
              <UpcomingBirthdays birthdays={firstApiResponse?.petsWithUpcomingBirthdays}/>
            </Col>
          </Row>
        </Col>

        {/* Appointments List */}
        <Col xxl={3} className="dashboard-appointments-column">
          <AppointmentsList className="flex-grow-1" 
            appointmentList={appointment}
            appointmentLoading={appointmentLoading}
            appointmentError={appointmentError}
            setAppointmentType={setAppointmentType}
            appointmentType={appointmentType}
            setAppointmentStatus={setAppointmentStatus}
            appointmentStatus={appointmentStatus}
            petTypes={petTypes || []}
            hoveredIndex={hoveredIndex} 
            setHoveredIndex={setHoveredIndex}
            handleRescheduleAppointment={handleRescheduleAppointment}
            handlePrintPrescription={handlePrintPrescription}
          />
        </Col>
      </Row>

      {/* Third Row: Lab Tests and Imaging Tests */}
      <Row className="mb-4 gap-0">
        <Col xs={12} md={6}>
          <BarChart
            title={appConstants.TOP_LAB_TESTS}
            labels={dashboardStoreData?.topLabTests?.map((test) => test._id) || []}
            data={dashboardStoreData?.topLabTests?.map((test) => test.count) || []}
            boolean={false}
            thickness={30}
          />
        </Col>
        <Col xs={12} md={6}>
          <BarChart
            title={appConstants.TOP_IMAGING_TESTS}
            labels={dashboardStoreData?.topImagingTests?.map((test) => test._id) || []}
            data={dashboardStoreData?.topImagingTests?.map((test) => test.count) || []}
            boolean={false}
            thickness={30}
          />
        </Col>
      </Row>

      {/* Fourth Row: Doctor's Schedule and Upcoming Birthdays */}
      <Row className="doctorSchedual">
        <Col xs={12} md={12}>
          <DoctorSchedule
            title={appConstants.DOCTORS_SCHEDULE}
            appointments={dashboardStoreData?.doctorsAppointment}
          />
        </Col>
      </Row>

    </div>
  )
}

function StatsCard({ title, value, icon }) {
  const isConsultaion = title === appConstants.CONSULTATIONS;
  let totalConsultation = 0;

  if(value && isConsultaion && Object.values(value) && Object.values(value).length){
    Object.values(value).forEach(value => {
      totalConsultation = totalConsultation + value?.due || 0 + value?.completed || 0;
    })
  }
   const [visitCount, urgentCount, virtualCount ]= extractConsultationsTypeCounts(value);

  return (
    <Card
      className="custom-card shadow-sm border-light h-100"
      style={{ borderRadius: "15px", padding: "0px" }}
    >
      <Card.Body className="d-flex align-items-center flex-wrap">
        <img
          src={icon}
          className="me-3"
          style={{ width: "40px", maxWidth: "100%", height: "auto" }}
          alt="icon"
        />
        <div className="flex-grow-1" style={{ width: "100%"}}>
          <Card.Title
            className="mb-0 text-truncate"
            style={{ fontSize: "1rem" }}
          >
            <div style={{ display: "flex", alignItems:'center', justifyContent: "space-between", marginBottom: title === appConstants.NEW_PATIENTS? "59px" : "5px"}}>
              <div style={{ fontSize: "1rem"}}>
                {title}
              </div>
              <div style={{ fontSize: "1.5rem"}}>
                {title === appConstants.CONSULTATIONS ? totalConsultation : title === appConstants.NEW_PATIENTS ? value : isNaN(value?.completed + value?.due) ? 0 : value?.completed + value?.due }
              </div>
            </div>
          </Card.Title>
          
          {title === appConstants.VACCINATIONS_DATA && (<div style={{ width: "100%", display: "flex",  justifyContent: "space-between" }}>
            <div style={{ flex: 0.4, padding: "5px" }}>
              <h6 style={{color: "#e75c25"}}>Completed</h6>
              <p><strong>{ title === appConstants.CONSULTATIONS ? 0 : value?.completed || 0}</strong></p>
            </div>
            <div style={{ flex: 0.4, padding: "5px" }}>
              <h6 style={{color: "#e75c25"}}>Due</h6>
              <p><strong>{title === appConstants.CONSULTATIONS ? 0 : value?.due || 0}</strong></p>
            </div>
          </div>)}

          {title === appConstants.CONSULTATIONS && (<div style={{ width: "100%", display: "flex",  justifyContent: "space-between" }}>
            <div style={{ flex: 0.3 }}>
              <h6 style={{color: "#e75c25"}}>Visit</h6>
              <p><strong>{visitCount}</strong></p>
            </div>
            <div style={{ flex: 0.3}}>
              <h6 style={{color: "#e75c25"}}>Virtural</h6>
              <p><strong>{virtualCount}</strong></p>
            </div>
            <div style={{ flex: 0.3}}>
              <h6 style={{color: "#e75c25"}}>Emergency</h6>
              <p><strong>{urgentCount}</strong></p>
            </div>
          </div>)}
        </div>
      </Card.Body>
    </Card>
  )
}

function AppointmentsList({ 
  appointmentList, 
   appointmentLoading,
  setAppointmentType, 
  appointmentType, 
  setAppointmentStatus, 
  appointmentStatus, 
  petTypes, 
  hoveredIndex, 
  setHoveredIndex,
  handleRescheduleAppointment,
  handlePrintPrescription
}) {

  const normalizeStatus = status =>
    status?.toString().trim().toLowerCase().replace(/[-_\s]+/g, "") || "scheduled"
  const listRef = React.useRef(null)

  const parseAppointmentTime = timeValue => {
    const rawTime = String(timeValue || "").trim()
    if (!rawTime) {
      return { hours: 0, minutes: 0 }
    }

    const normalized = rawTime.replace(/\s+/g, " ").toUpperCase()
    const twelveHourMatch = normalized.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/)
    if (twelveHourMatch) {
      let hours = Number(twelveHourMatch[1])
      const minutes = Number(twelveHourMatch[2])
      const meridiem = twelveHourMatch[3]

      if (meridiem === "AM") {
        hours = hours === 12 ? 0 : hours
      } else {
        hours = hours === 12 ? 12 : hours + 12
      }

      return { hours, minutes }
    }

    const twentyFourHourMatch = normalized.match(/^(\d{1,2}):(\d{2})$/)
    if (twentyFourHourMatch) {
      return {
        hours: Number(twentyFourHourMatch[1]),
        minutes: Number(twentyFourHourMatch[2]),
      }
    }

    return { hours: 0, minutes: 0 }
  }

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = 0
    }
  }, [appointmentStatus, appointmentType, appointmentList])

  const getPetName = appointment =>
    appointment?.petObjectId?.fullName ||
    appointment?.petObjectId?.petName ||
    appointment?.petObjectId?.name ||
    appointment?.petName ||
    appointment?.pet?.fullName ||
    "Pet"

  const getOwnerName = appointment =>
    appointment?.parentId?.fullName ||
    appointment?.parentName ||
    appointment?.ownerName ||
    appointment?.petParentName ||
    ""

  const getVisitType = appointment => getAppointmentDisplayLabel(appointment)

  const getPetType = appointment =>
    appointment?.petType ||
    appointment?.petObjectId?.petType ||
    appointment?.pet?.petType ||
    ""

  const parseAppointmentDateTime = appointment => {
    const datePart = appointment?.date ? new Date(appointment.date) : null
    if (!datePart || Number.isNaN(datePart.getTime())) {
      return 0
    }

    const { hours, minutes } = parseAppointmentTime(appointment?.time)
    const merged = new Date(datePart)
    merged.setHours(hours, minutes, 0, 0)
    return merged.getTime()
  }

  const filteredAppointments = (appointmentList || []).filter(appointment => {
    const selectedStatus = normalizeAppointmentStatus(appointmentStatus)
    const status = normalizeStatus(appointment?.status)
    const statusMatches =
      selectedStatus === "all"
        ? true
        : selectedStatus === "cancelled"
          ? status === "cancelled" || status === "canceled"
          : status === normalizeStatus(selectedStatus)

    const selectedPetType = appointmentType?.toString().trim().toLowerCase()
    const petType = getPetType(appointment).toString().trim().toLowerCase()
    const petTypeMatches = !selectedPetType || selectedPetType === "all" || !petType || petType === selectedPetType

    return statusMatches && petTypeMatches
  })

  const sortedAppointments = [...filteredAppointments].sort((left, right) => {
    const leftDate = parseAppointmentDateTime(left)
    const rightDate = parseAppointmentDateTime(right)
    if (rightDate !== leftDate) {
      return rightDate - leftDate
    }

    const leftCreatedAt = left?.createdAt ? new Date(left.createdAt).getTime() : 0
    const rightCreatedAt = right?.createdAt ? new Date(right.createdAt).getTime() : 0
    if (rightCreatedAt !== leftCreatedAt) {
      return rightCreatedAt - leftCreatedAt
    }

    return String(right?.time || "").localeCompare(String(left?.time || ""))
  })

  const visibleAppointments = sortedAppointments

  return (
    <Card className="mb-4 appointment-card dashboard-card dashboard-appointments-card" style={{ borderRadius: "15px" }}>
      <Card.Body>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title">Appointments</h5>
          {/* Dropdowns */}
          <div className="d-flex justify-content-start mb-1 p-0 ml-1">
            <Dropdown as={ButtonGroup}>
              <Dropdown.Toggle variant="light" className="dropdown-toggle" style={{ padding: "4px 6px"}}>
                {capitalizeFirstLetter(appointmentStatus)} <IconSVG icon='arrowDown' />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ marginTop: "35px" }}>
                {["All", "Scheduled", "Rescheduled", "Check-In", "Cancelled", "Completed"].map((status, index) => {
                  return (
                    <Dropdown.Item key={index} onClick={() => setAppointmentStatus(status)}>
                      {capitalizeFirstLetter(status)}
                    </Dropdown.Item>
                  )
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>


       {/* Appointment List */}
<ListGroup
  ref={listRef}
  variant="flush"
  className="appointments-list"
>
  {appointmentLoading ? (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "250px" }}
  >
    <div className="spinner-border text-primary" role="status" />
  </div>
) : visibleAppointments && visibleAppointments.length ? (
    visibleAppointments?.map((appointment, index) => {
      const statusColorMap = {
        completed: "#2E7D32",   // Green
        scheduled: "#6A1B9A",   // Purple
        cancelled: "#F5222D",   // Red
        canceled: "#F5222D",    // Red
        checkin: "#E6A23C",     // Orange
        "check-in": "#E6A23C",
        checkIn: "#E6A23C",
        accepted: "#652B88",
        rescheduled: "#CC7722",
      };

      const normalizedAppointmentStatus = normalizeStatus(appointment?.status);

      const appointmentDate = appointment?.date
        ? new Date(appointment.date)
        : null;

      const isPastScheduled =
        normalizedAppointmentStatus === "scheduled" &&
        appointmentDate &&
        appointmentDate < new Date();

      const borderColor = isPastScheduled
        ? "#9E9E9E"
        : statusColorMap[normalizedAppointmentStatus] || "#F26D21";

      return (
        <ListGroup.Item
          key={index}
          className="d-flex align-items-center"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
          style={{ position: "relative" }}
        >
          <div
            style={{
              borderLeft: `5px solid ${borderColor}`,
              paddingLeft: "10px",
              width: "100%",
            }}
          >
            <div>
              {getPetType(appointment) ? `${getPetType(appointment)} - ` : ""}
              <strong>{getPetName(appointment)}</strong>
              {getOwnerName(appointment) ? ` (${getOwnerName(appointment)})` : ""} -{" "}
              {getVisitType(appointment)}
            </div>

            <small className="text-muted">
              {appointment?.time || "No time"} - {appointment?.duration || appointment?.durationMinutes || appointment?.slotDuration || 30}min -{" "}
              {appointment?.date ? new Date(appointment.date).toLocaleDateString() : "No date"}
            </small>
          </div>

          <div
            className={`sliding-options ${
              hoveredIndex === index ? "slide-in" : ""
            }`}
          >
            <div
              className="option"
              onClick={() => handleRescheduleAppointment(appointment)}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Reschedule Appointment"
            >
              <IconSVG icon={"reschedule"} />
            </div>

            <div
              className="option"
              onClick={() => handlePrintPrescription(appointment?._id)}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Print Prescription"
            >
              <IconSVG icon={"print"} />
            </div>
          </div>
        </ListGroup.Item>
      );
    })
) : (
    <div className="flex-center">
      <h6>No appointment found.</h6>
    </div>
  )}
</ListGroup>
      </Card.Body>
    </Card>
  )
}

export default Dashboard

